import React, { FC, useState } from 'react';
import Svg from 'svg-inline-react';
import classnames from 'classnames';
import { OutsideClick } from '@src/components/OutsideClick';
import FrDropdown from '@src/svgs/fr-dropdown.svg';
import { SortingOptionsProps } from './props';
import './styles.scss';

export const SortingOptions: FC<SortingOptionsProps> = ({ selectedOption, onOptionChange, onClear, options }) => {
  const [isShown, setIsShown] = useState(false);

  const selectedOptionLabel = options.find(option => option.value === selectedOption)?.label;

  return (
    <OutsideClick addOutsideClickListener={isShown} onOutsideClick={() => setIsShown(false)}>
      <div className="talent-pipeline-sorting-option-select">
        <div className="talent-pipeline-sorting-option-select__selected" onClick={() => setIsShown(!isShown)}>
          {selectedOptionLabel}

          <Svg
            className={classnames(
              'talent-pipeline-sorting-option-select__button-icon',
              isShown && 'talent-pipeline-sorting-option-select__button-icon--rotate',
            )}
            src={FrDropdown}
          />
        </div>

        {isShown && (
          <div className="talent-pipeline-sorting-option-select__dropdown">
            {options.map(option => {
              return (
                <div
                  className="talent-pipeline-sorting-option-select__dropdown-item"
                  key={option.label}
                  onClick={() => {
                    if (!option.value) {
                      onClear();
                    }

                    onOptionChange(option.value);

                    setIsShown(false);
                  }}
                >
                  <div className="talent-pipeline-sorting-option-select__dropdown-label">{option.label}</div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </OutsideClick>
  );
};
